import { useState } from 'react';
import { Box, Link } from '@mui/material';

type TableV3TruncatedListProps = {
  items: string[];
  maxItems?: number;
};

export const TableV3TruncatedList: React.FC<TableV3TruncatedListProps> = ({
  items,
  maxItems = 4
}) => {
  const [showAll, setShowAll] = useState(false);

  if (items.length === 0) return null;

  const visibleItems = showAll ? items : items.slice(0, maxItems);
  const remainingCount = items.length - maxItems;

  return (
    <Box>
      {visibleItems.join(', ')}
      {remainingCount > 0 && (
        <>
          {' '}
          <Link
            component="button"
            onClick={() => setShowAll(!showAll)}
            sx={{
              fontSize: 'inherit',
              cursor: 'pointer',
              textDecoration: 'none',
              color: 'primary.main',
              '&:hover': {
                textDecoration: 'underline'
              },
              mb: 0.5
            }}
          >
            {showAll ? 'See less' : `+${remainingCount} more`}
          </Link>
        </>
      )}
    </Box>
  );
};
